import { useContext } from 'react';

import { Dropdown, Menu } from '@arco-design/web-react';
import { IconDown, IconLanguage } from '@arco-design/web-react/icon';

import { ConfigContext } from '@/components/ConfigProvider/configProvider';

import styles from '../styles/index.module.less';

export default function SelectLang() {
  const { lang, setLang } = useContext(ConfigContext);

  const selectLang = (newLang: 'zh-cn' | 'en') => {
    if (lang === newLang) return;
    setLang(newLang);
    window.location.reload();
  };

  const currentLangLabel = lang === 'zh-cn' ? '简体中文' : 'English';

  const dropList = (
    <Menu className={styles['lang-dropdown-menu']} selectedKeys={[lang]}>
      <Menu.Item key="en" onClick={() => selectLang('en')}>
        English
      </Menu.Item>
      <Menu.Item key="zh-cn" onClick={() => selectLang('zh-cn')}>
        简体中文
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown droplist={dropList} position="bl">
      <span className={`${styles['navbar-right-btn']} ${styles['lang-dropdown-trigger']}`}>
        <IconLanguage className={styles['lang-dropdown-icon']} />
        <span>{currentLangLabel}</span>
        <IconDown className={styles['lang-dropdown-arrow']} />
      </span>
    </Dropdown>
  );
}
